import React from 'react'
import CompLayout from '../../theme/Layout/CompLayout'
import { Alert } from '../../theme/Components/Alert/Alert'
import { AlertSnippet } from '../../theme/Components/Alert/CodeSnippet';

export const Success = () => {
  const alertConfigurations = [
    { title: "Normal", component: <Alert variant='success' />, desc: "The default version of the success alert, which notifies the user of positive outcomes" },
    { title: "with prefix", component: <Alert variant='success' prefix />, desc: "Variant of a success alert, it has an icon or label at the start for easy identification" },
    { title: "with Action Buttons", component: <Alert variant='success' action />, desc: "Variant of a success alert, it has buttons for the user to take relevant actions based on the success message" },
    { title: "without close button", component: <Alert variant='success' closable={false} />, desc: "Variant of a success alert which cannot be closed manually by the user and goes away after a delay" },
    { title: "with prefix and action", component: <Alert variant='success' prefix action />, desc: "Variant of a success alert which has an icon or label in the front for easy identification and buttons to help users take actions" }
  ];

  return (
    <div>
      <h3 className="section-title">success</h3>
      <p className="comp-desc">
        Type of alert that notifies the user of positive outcomes within the sytem and has a green background.
      </p>
      <div className="flex mt-[32px] gap-[32px] flex-col">
        {alertConfigurations.map(({ title, component, desc }, i) => (
          <CompLayout
            key={i}
            component={component}
            title={title}
            desc={desc}
            code={AlertSnippet.success[i].code}
          />
        ))}
      </div>
    </div>
  )
}
